import React from "react";

const Details = ({ rowData }) => {
  if (!rowData) return <p>No data available</p>;

  const fields = [
    { label: "ID", key: "id" },
    { label: "Kiosk ID", key: "kioskId" },
    { label: "Kiosk Name", key: "kioskName" },
    { label: "Transaction Type", key: "transactionType" },
    { label: "Transaction ID", key: "transactionId" },
    { label: "Transaction Date", key: "transactionDate" },
    { label: "Amount", key: "amount" },
    { label: "Service Fee", key: "serviceFee" },
    { label: "Status", key: "status" },
    { label: "Sender Wallet ID", key: "senderWalletId" },
    { label: "Receiver Wallet ID", key: "receiverWalletId" },
    { label: "Recipient Mobile Number", key: "recipientMobileNumber" },
    { label: "Reference Number", key: "referenceNumber" },
    { label: "Remarks", key: "remarks" },
    { label: "Initiation Date Time", key: "initiationDateTime" },
    { label: "Completion Date Time", key: "completionDateTime" },
  ];

  return (
    <div className="main-form">
      <div className="p-fluid formgrid grid">
        {fields.map(({ label, key }) => (
          <div key={key} className="field col-12 md:col-4 mb-3">
            <label>{label}</label>
            <p>{rowData[key] || "N/A"}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Details;
